import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivityStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-activity-status',
  templateUrl: './activity-status.component.html',
  styleUrls: ['./activity-status.component.scss']
})
export class ActivityStatusComponent implements OnChanges {

  activitystatusForm: FormGroup;
  activitystatusFormArray: FormGroup;
  control = new FormControl();
  @Input() activitystatuss: ActivityStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() activitystatus = new EventEmitter<ActivityStatusDto[]>()
  @Output() deleteActivityStatusEvent = new EventEmitter<any>()

    selectedActivityStatus: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createActivityStatusForm();
    }

    createActivityStatusForm() {
      this.activitystatusForm = this.fb.group({
        ActivityStatusName: ['', Validators.required],
        id: null
        });
        this.activitystatusFormArray = this.fb.group({ ActivityStatuss: this.fb.array([])
          });
        this.setActivityStatus();
    }

  // method to display activitystatuss
  setActivityStatus() {
    const control  = this.activitystatusFormArray.controls.ActivityStatuss as FormArray;
    this.activitystatuss.forEach( e => {
      control.push(
        this.fb.group({
          ActivityStatusName: e.ActivityStatusName,
          id: e.id
        })
      );
    });
  }


  // method to add ActivityStatus
  addActivityStatus(value: ActivityStatusDto) {
    const control  = this.activitystatusFormArray.controls.ActivityStatuss as FormArray;
    control.insert(0,
          this.fb.group({
            ActivityStatusName: value.ActivityStatusName,
            id: null
          })
       );
  }

  selectActivityStatus(value) {}

  // method to delete activitystatus from arrary list
  deleteActivityStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.activitystatusFormArray.controls.ActivityStatuss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.activitystatuss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.activitystatuss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: ActivityStatusDto) {
    if(this.activitystatusForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.activitystatusFormArray.get('ActivityStatuss')['controls'][this.selectedIndex].patchValue({ActivityStatusName: formValue.ActivityStatusName});
    } else {
      this.addActivityStatus(formValue);
    }
    this.selectedIndex = null;
    this.activitystatusForm.reset()
  }

  onEdit(index, value: ActivityStatusDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.activitystatusForm.patchValue({ActivityStatusName: value.ActivityStatusName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.activitystatusForm.reset();
  }

  onSubmit(formValue: ActivityStatusDto[]) {
  this.activitystatus.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteActivityStatusEvent.emit(this.filteredDelete);
  }
  }


}
